<template>
  <div :class="styles.community">
    <van-nav-bar class="nav-bar" :title="$t('foorter.community')" />

    <div :class="styles.listContainer">
      <div :class="styles.listWrapper">
        <div
          :class="styles.listItem"
          v-for="v in data.communityData"
          :key="v.id"
          @click="toDetail(v.id)"
        >
          <img :src="`/img/community/img-${v.id}.jpg`" alt="community" />
          <div :class="styles.listItemTitle">{{ v.title }}</div>
        </div>
      </div>
    </div>
    <div style="padding-bottom: 35px"></div>
  </div>
</template>

<script>
import data from "./data.json";
import styles from "./style.module.scss";

export default {
  data() {
    return {
      styles,
      data,
    };
  },
  methods: {
    toDetail(id) {
      this.$router.push(`/Community/detail/${id}`);
    },
  },
  created() {
    this.getGameItem(); //获取首页游戏列表
    this.getLotteryItem();
  },
};
</script>

<style lang='less' scoped>
.nav-bar {
  background: unset;
  height: 100px;
  color: #000;
}
.van-nav-bar {
  line-height: 50px;
}
::v-deep .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: #000;
  font-size: 35px;
}
::v-deep .van-nav-bar__content {
  height: 100px;
}
</style>
